import { RouterProvider } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import client from '@/graphql/client';
import { AuthProvider } from '@/app/auth/AuthContext';
import { ThemeSwitcherProvider } from '@gastrosoft/shared/theme';
import { brandConfigs } from '@/theme/themeConfig';
import { OrganizationProvider } from '@/app/contexts/OrganizationContext';
import { SetupProvider } from '@/app/contexts/SetupContext';
import { router } from '@/app/router';

export default function App() {
  return (
    <ApolloProvider client={client}>
      <AuthProvider>
        <ThemeSwitcherProvider brandConfigs={brandConfigs} brandOrder={['orda-pos', 'gastrosoft']}>
          <OrganizationProvider>
            <SetupProvider>
              <RouterProvider router={router} />
            </SetupProvider>
          </OrganizationProvider>
        </ThemeSwitcherProvider>
      </AuthProvider>
    </ApolloProvider>
  );
}
